<style lang="scss">
.package-title {
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #ff9900;
    color: #fff;
}
</style>

<template>
    <div>
        <div class="bg-fff margin-top-20 padding-bottom-20">
            <header
                class="package-title font-bold"
            >{{$t('erp.b2c.parcel_information',{defaultValue:'包裹信息'})}}</header>
            <Table
                class="margin-10"
                :columns="columns"
                :data="formList"
                size="small"
                ref="table"
                border
                stripe
            ></Table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    props: ["comPackages", "type", "status", "parentId"],
    data() {
        return {};
    },
    created() {
    },
    computed: {
        packStatus() {
            return [{
                value: 0,
                label: 'UNKNOWN',
                color: ''
            }, {
                value: 1,
                label: 'PRE TRANSIT',
                color: 'color-success'
            }, {
                value: 2,
                label: 'IN TRANSIT',
                color: 'color-primary'
            }, {
                value: 3,
                label: 'OUT FOR DELIVERY',
                color: 'color-warning'
            }, {
                value: 4,
                label: 'DELIVERED',
                color: ''
            }, {
                value: 5,
                label: 'AVAILABLE FOR PICKUP',
                color: 'color-success'
            }, {
                value: 6,
                label: 'RETURN TO SENDER',
                color: 'color-error'
            }, {
                value: 7,
                label: 'FAILURE',
                color: 'color-error'
            }, {
                value: 8,
                label: 'CANCELLED',
                color: ''
            },{
                value: 9,
                label: 'ERROR',
                color: 'color-error'
            },{
                value: 11,
                label: "Label Created",
                color: "",
            },];
        },
        formList() {
            let arr = null;
            let array = this.comPackages.concat();
            arr =
                this.comPackages.filter((item) => {
                    return item.packageFlag == 0;
                }) || {};

            console.log(this.comPackages, array)
            if (arr.length < 1) {
                return this.comPackages || [];
            } else {
                return arr || [];
            }
        },
        columns() {
            let that = this;
            return [
                {
                    title: "Tracking NO",
                    key: "trackingNo",
                    render(h, { row }) {
                        return <div>{row.trackingNo}</div>;
                        // if (row.packageUrl) {
                        //     return h(
                        //         "a",
                        //         {
                        //             style: "float:left;padding:9px 6px;",
                        //             attrs: {
                        //                 href: row.packageUrl,
                        //                 target: "_blank",
                        //             },
                        //         },
                        //         row.trackingNo
                        //     );
                        // } else return <div>{row.trackingNo}</div>;
                    },
                },
                {
                    title: "Carrier",
                    key: "carrier",
                    render(h, { row }) {
                        return <div>{row.carrier}</div>;
                    },
                },
                {
                    title: "ERP SKU",
                    key: "erpSku",
                    render(h, { row }) {
                        return <div>{row.erpSku}</div>;
                    },
                },
                {
                    title:
                        this.$t("erp.b2c.package_size", {
                            defaultValue: "长宽高",
                        }) + "(inch)",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {this.handleUnit(
                                    row.packageLength,
                                    "cm",
                                    "inch"
                                )}
                                *
                                {this.handleUnit(
                                    row.packageWidth,
                                    "cm",
                                    "inch"
                                )}
                                *
                                {this.handleUnit(
                                    row.packageHeigth,
                                    "cm",
                                    "inch"
                                )}
                            </div>
                        );
                    },
                },
                {
                    title:
                        this.$t("global.common.weight", {
                            defaultValue: "重量",
                        }) + "(lbs)",
                    key: "packageWeight",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {this.handleUnit(row.packageWeight, "g", "lb")}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("erp.b2c.package_logistics_status", {
                        defaultValue: "物流状态",
                    }),
                    render(h, { row }) {
                        let label = that.packStatus.filter((item) => {
                            return item.value === row.logisticStatus;
                        })[0];
                        return <div>{label ? label.label : row.logisticStatus}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.quantity_shipped", {
                        defaultValue: "发货数量",
                    }),
                    key: "shipedQuantity",
                    render(h, { row }) {
                        return <div>{row.shipedQuantity}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.search_outtime", {
                        defaultValue: "发货时间",
                    }),
                    key: "shipmentDate",
                    render(h, { row }) {
                        return <div>{row.shipmentDate}</div>;
                    },
                },
            ];
        },
    },
    methods: {

    },
};
</script>

